import { ApolloLink } from '@apollo/client';

export const rumHandler = (publishFrustation, publishAction, publishPerformanceStats) => {
  return new ApolloLink((operation, forward) => {
    operation.setContext({ start: Date.now() });
    return forward(operation).map((data) => {
      const start = operation.getContext().start;
      const timeTaken = Date.now() - start;

      // starting with a high 2.5 seconds threshold
      if (timeTaken > 2500) {
        publishFrustation(
          'GRAPHQL',
          new Error(`Long query load (${timeTaken}ms) - queryName:${operation.operationName}`),
        );
      }

      if (publishPerformanceStats) {
        publishAction('GRAPHQL-STAT', {
          operationName: operation.operationName,
          timeTaken: timeTaken,
        });
      }

      return data;
    });
  });
};
